import _ from 'lodash';
import ShopForm from './ShopForm';
import { Creative } from 'core/creative/Creative';
import { BasicFormProps } from './BasicFormProps';
import { CreativeSetupFlowPageModel } from 'containers/Creatives/CreativeSetupFlow/CreativeSetupFlowPageModelInterface';
import { Product } from 'core/product/Product';
import { ProductSelectFormModel } from './ProductSelectFormModel';

export type ShopFormProps = {
  readonly model: ShopFormModel;
  readonly hintModalData?: any;
  readonly setHintModalData: (modalData: any) => void;
} & BasicFormProps;

export class ShopFormModel extends ProductSelectFormModel {
  constructor(
    public flowPageModel: CreativeSetupFlowPageModel,
    products: Product[] = [],
  ) {
    super(flowPageModel, products);
    this.removeSelectProduct = this.removeSelectProduct.bind(this);
  }

  public needBannerUrl: boolean = true;

  getFormContent = (): any => {
    return ShopForm;
  };

  getInitTypeProperties() {
    return {
      primaryProduct: undefined,
    };
  }

  removeSelectProduct() {
    this.handleRemoveSelect();
  }

  getFormModelData(creative: Creative) {
    const creativeBasic: any = _.omit(creative.basic, [
      'id',
      'srcType',
      'creativeValues',
      'product',
    ]);
    return {
      basic: {
        ...creativeBasic,
        typeProperties: {
          primaryProduct: creative.basic.product,
        },
        brand: {
          label: creativeBasic.bannerExtra?.brandName,
          value: creativeBasic.bannerExtra?.webBrandNo,
        },
        cnCode: {
          label: creativeBasic.bannerExtra?.categoryName,
          value: creativeBasic.bannerExtra?.categoryCode,
        },
      },
    };
  }
}
